import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import { Line } from "react-chartjs-2"
import numeral from "numeral"
import colorArray from "helpers/colorArray"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import createTrend from "trendline"
import ReactSelect from "components/ReactSelect"
import { Formik, Field, Form, FieldArray } from "formik"
import moment from "moment-timezone"
import NumberField from "components/NumberField"
import helpers from "helpers/helpers"
import * as Yup from "yup"
import Switch from "react-switch"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import settings from "settings"
var randomColors = helpers.randomColors()
//? The sales use the date, the specs and floorplans are all using data we as of now.  Floorplans not used in school district.

class Segmentation extends Component {
	constructor(props) {
		super(props)
		let manualLotTypes = localStorage.getItem("segmentation__manualLotTypes")
		let manualBuilder = localStorage.getItem("segmentation__manualBuilder")
		let manualSchools = localStorage.getItem("segmentation__manualSchools")
		this.state = {
			columns: [
				{
					Header: "Type",
					accessor: "queryType",
					filterMethod: (f, r) => helpers.tableText(f, r, "queryType"),
				},
				{
					Header: "Lot Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Sale Date",
					accessor: "date",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("MM/DD/YY")
						return ""
					},
				},
				{
					Header: "Price",
					accessor: "price",
					Cell: (v) => {
						if (v.value) return numeral(v.value).format("$0,0")
						return ""
					},
					Footer: (props) => helpers.tableAverages(props, "price", "$0,0"),
				},
				{
					Header: "Sq Ft",
					accessor: "sqft",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
					Footer: (props) => helpers.tableAverages(props, "sqft", "0,0"),
				},
				{
					Header: "PPSQFT",
					accessor: "ppsqft",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					Footer: (props) => helpers.tableAverages(props, "ppsqft", "$0,0"),
				},
			],
			activeLotTypes: [],
			builderColumns: [
				{
					Header: "Type",
					accessor: "queryType",
					filterMethod: (f, r) => helpers.tableText(f, r, "queryType"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Sale Date",
					accessor: "date",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("MM/DD/YY")
						return ""
					},
				},
				{
					Header: "Price",
					accessor: "price",
					Cell: (v) => {
						if (v.value) return numeral(v.value).format("$0,0")
						return ""
					},
					Footer: (props) => helpers.tableAverages(props, "price", "$0,0"),
				},
				{
					Header: "Sq Ft",
					accessor: "sqft",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
					Footer: (props) => helpers.tableAverages(props, "sqft", "0,0"),
				},
				{
					Header: "PPSQFT",
					accessor: "ppsqft",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					Footer: (props) => helpers.tableAverages(props, "ppsqft", "$0,0"),
				},
			],
			schoolColumns: [
				{
					Header: "School District",
					accessor: "school",
					filterMethod: (f, r) => helpers.tableText(f, r, "school"),
				},
				{
					Header: "Lot Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Date",
					accessor: "date",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("MM/DD/YY")
						return ""
					},
				},
				{
					Header: "Price",
					accessor: "price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Sq Ft",
					accessor: "sqft",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
				},
			],
			manualLotTypeFields: {
				lot_type: "",
				sqft_low: 0,
				sqft_high: 0,
				price_low: 0,
				price_high: 0,
			},
			manualBuilderFields: {
				lot_type: "", // actually the builder but easier for the logic if everything named the same
				sqft_low: 0,
				sqft_high: 0,
				price_low: 0,
				price_high: 0,
			},
			manualSchoolFields: {
				lot_type: "",
				sqft_low: 0,
				sqft_high: 0,
				price_low: 0,
				price_high: 0,
			},
			lotTypeDatasets: {},
			lotTypeTableData: [],
			lotTypeOptions: {},
			builderOptions: {},
			schoolOptions: {},
			builderDatasets: {},
			builderTableData: [],
			schoolDatasets: {},
			schoolTableData: [],
			showSales: true,
			showSquareFootage: false,
			showIndividual: false,
			showFloorplans: false,
			showSpecs: false,
			showLabels: true,
			zeroBasedAxis: false,
			includePremiums: true, // if true, data will include lots with premiums.  If false, data will exclude lots with premiums.
			showIndividualFloorplans: false,
			showIndividualSpecs: false,
			showPPSQFT: false,
			showSpecsPPSQFT: false,
			originalLotTypeDataSets: null,
			originalBuilderDataSets: null,
			originalSchoolDataSets: null,
			manualLotTypeModal: false,
			manualLotTypes: manualLotTypes ? JSON.parse(manualLotTypes) : false,
			manualBuilderModal: false,
			manualBuilder: manualBuilder ? JSON.parse(manualBuilder) : false,
			manualSchoolsModal: false,
			manualSchools: manualSchools ? JSON.parse(manualSchools) : false,
			builderColors: {},
		}
		this.model = {
			label: "",
			data: [
				{ x: 0, y: 0 },
				{ x: 0, y: 0 },
			],
			borderColor: "",
			fill: false,
			lineTension: 0,
			borderWidth: 5,
			pointHoverBorderWidth: 0,
			pointHoverRadius: 3,
			pointHoverBackgroundColor: "",
			pointBackgroundColor: "",
			backgroundColor: "",
			projection: false,
			borderDash: [0, 0],
		}
	}

	componentDidMount() {
		this.buildAll()
	}

	componentDidUpdate(prev, prevState) {
		if (!_.isEqual(prev, this.props)) {
			this.buildAll()
		}
		if (!_.isEqual(prevState.manualLotTypes, this.state.manualLotTypes)) {
			this.addManualLinesLotType()
			this.buildLotTypeData()
		}
		if (!_.isEqual(prevState.manualBuilder, this.state.manualBuilder)) {
			this.addManualBuilder()
			this.buildBuilderData()
		}
		if (!_.isEqual(prevState.manualSchools, this.state.manualSchools)) {
			this.addManualSchools()
			this.buildSchoolData()
		}
	}

	addManualLinesLotType = (set) => {
		let prev = _.cloneDeep(this.state.originalLotTypeDataSets)
		let len = this.state?.originalLotTypeDataSets?.datasets?.length
		if (set) {
			prev = set
			len = set.datasets.length
		}

		_.forEach(this.state.manualLotTypes, (v) => {
			len++
			let model = _.cloneDeep(this.model)
			model.data = [
				{ x: 0, y: 0 },
				{ x: 0, y: 0 },
			]
			let color = colorArray[len]
			model.label = v.lot_type
			model.backgroundColor = color
			model.borderColor = color
			model.pointBackgroundColor = color
			model.pointHoverBackgroundColor = color
			model.labelGroup = "Manual"
			model.borderDash = [15, 5]
			model.data[0].x = parseInt(v.sqft_low)
			model.data[0].y = parseInt(v.price_low)
			model.data[1].x = parseInt(v.sqft_high)
			model.data[1].y = parseInt(v.price_high)
			prev.datasets.push(model)
			prev.labels.push(v.lot_type)
		})
		if (set) return prev
		this.setState({ lotTypeDatasets: prev })
	}

	addManualBuilder = (set, colors) => {
		let prev = _.cloneDeep(this.state.originalBuilderDataSets)
		if (set) {
			prev = set
		}
		if (!colors) colors = this.state.builderColors
		_.forEach(this.state.manualBuilder, (v) => {
			let model = _.cloneDeep(this.model)
			model.data = [
				{ x: 0, y: 0 },
				{ x: 0, y: 0 },
			]
			let color = colors[v.lot_type]
			model.label = v.lot_type
			model.backgroundColor = color
			model.borderColor = color
			model.pointBackgroundColor = color
			model.pointHoverBackgroundColor = color
			model.labelGroup = "Manual"
			model.borderDash = [15, 5]
			model.data[0].x = parseInt(v.sqft_low)
			model.data[0].y = parseInt(v.price_low)
			model.data[1].x = parseInt(v.sqft_high)
			model.data[1].y = parseInt(v.price_high)
			prev.datasets.push(model)
			prev.labels.push(v.lot_type)
		})
		if (set) return prev
		this.setState({ builderDatasets: prev })
	}

	addManualSchools = (set) => {
		let prev = _.cloneDeep(this.state.originalSchoolDataSets)
		let len = this.state?.originalSchoolDataSets?.datasets?.length
		if (set) {
			prev = set
			len = set.datasets.length
		}

		_.forEach(this.state.manualSchools, (v) => {
			len++
			let model = _.cloneDeep(this.model)
			model.data = [
				{ x: 0, y: 0 },
				{ x: 0, y: 0 },
			]
			let color = colorArray[len]
			model.label = v.lot_type
			model.backgroundColor = color
			model.borderColor = color
			model.pointBackgroundColor = color
			model.pointHoverBackgroundColor = color
			model.labelGroup = "Manual"
			model.borderDash = [15, 5]
			model.data[0].x = parseInt(v.sqft_low)
			model.data[0].y = parseInt(v.price_low)
			model.data[1].x = parseInt(v.sqft_high)
			model.data[1].y = parseInt(v.price_high)
			prev.datasets.push(model)
			prev.labels.push(v.lot_type)
		})
		if (set) return prev
		this.setState({ schoolDatasets: prev })
	}

	buildAll = () => {
		this.buildLotTypeData()
		this.buildBuilderData()
		this.buildSchoolData()
	}

	generateFloorplans = () => {
		let useManual = settings?.useFloorplanManualBasePricing
		let floorplans = _.filter(this.props.payload.public.floorplans, (v) => {
			if (!v.status) return false
			let found = false
			_.forEach(v.lot_types, (r) => {
				if (useManual) {
					if (this.props.activeProperties[0] == r.property && r.manual_base_price) {
						found = true
						return false
					}
				} else {
					if (this.props.activeProperties[0] == r.property && r.base_price) {
						found = true
						return false
					}
				}
			})
			if (found) return true
		})

		return floorplans
	}

	buildLotTypeData() {
		let model = _.cloneDeep(this.model)
		let labels = []
		let datasets = []
		let lotTypeTableData = []
		// Caldwell - only wants to use base pricing coming from the developer, not anything put in via feeds.
		let useManual = settings?.useFloorplanManualBasePricing
		//? Actual Sales
		if (this.state.showSales) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					address: v.address,
				})
			})

			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})

			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let school = _.find(this.props.payload.public.isds, { id: v.isd })
				if (!lotType || !v.sqft || !v.price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
				// Table Data
				lotTypeTableData.push({
					queryType: "Sale",
					type: lotType.name,
					date: v.sale_date,
					price: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					sqft: v.sqft,
					isd: school ? school.code : "",
				})
			})
			//console.log(trends)
			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.label = `Sales | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.yAxisID = "sales-price"
				datasets.push(o)
			})
		}
		//? Individual Sales scatter
		if (this.state.showIndividual) {
			let trendStore = {}
			_.forEach(this.props.payload.sales.current, (v) => {
				//if (!this.state.includePremiums && v.premium) return
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					address: v.address,
				})
			})
			let count = 0
			_.forEach(trendStore, (v, k) => {
				labels.push(k)
				//let lookup = _.find(datasets, { label: k })
				//let color = lookup ? lookup.backgroundColor : colorArray[count]
				let color = colorArray[count]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: k,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(k)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				datasets.push({
					label: `Sale | ${k}`,
					labelGroup: k,
					type: "scatter",
					hidden: false,
					backgroundColor: color,
					yAxisID: "sales-price",
					data: v,
				})
				count++
			})
		}
		//? Square Footage
		if (this.state.showSales && this.state.showSquareFootage) {
			let data = []
			_.forEach(this.props.payload.public.lot_types, (v) => {
				if (this.props.activeProperties[0] !== v.property) return
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.id)) return
				if (v.sqft_min && v.sqft_max) {
					data.push({
						label: v.name,
						data: [
							{ x: v.sqft_min, y: 0 },
							{ x: v.sqft_max, y: 0 },
						],
					})
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.label = `Sqft | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [5, 3]
				o.yAxisID = "sales-price"
				datasets.push(o)
			})
		}
		//? Floorplans
		if (this.state.showFloorplans) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			let floorplans = this.generateFloorplans()
			_.forEach(floorplans, (v) => {
				if (!v.sqft) return
				_.forEach(v.lot_types, (r) => {
					if (this.props.activeProperties[0] !== r.property) return
					let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
					if (!lotType) return
					if (useManual && !r.manual_base_price) return
					else if (!useManual && !r.base_price) return

					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
					let path = `${lotType.name.toString()}`
					if (!_.has(trendStore, path)) {
						trendStore[path] = []
					}
					trendStore[path].push({
						x: v.sqft,
						y: useManual ? r.manual_base_price : r.base_price,
						name: v.name,
					})
				})
			})
			trends = []
			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})
			lowHighs = {}
			_.forEach(floorplans, (v) => {
				if (!v.sqft) return
				_.forEach(v.lot_types, (r) => {
					if (this.props.activeProperties[0] !== r.property) return
					let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
					if (!lotType) return
					if (useManual && !r.manual_base_price) return
					else if (!useManual && !r.base_price) return
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
					let path = `${lotType.name.toString()}`
					if (!_.has(lowHighs, path)) {
						lowHighs[path] = {
							low: { x: 99999, y: 0 },
							high: { x: 0, y: 0 },
						}
					}

					if (v.sqft < lowHighs[path].low.x) {
						lowHighs[path].low = {
							x: v.sqft,
							y: v.price,
						}
					}
					if (v.sqft > lowHighs[path].high.x) {
						lowHighs[path].high = {
							x: v.sqft,
							y: v.price,
						}
					}
					// Table Data
					lotTypeTableData.push({
						queryType: "Floorplan",
						type: lotType.name,
						floorplan: v.name,
						price: useManual ? r.manual_base_price : r.base_price,
						sqft: v.sqft,
					})
				})
			})
			storage = {}
			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.labelGroup = r.label
				o.data = r.data
				o.label = `Floorplan | ${r.label}`
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [15, 5]
				o.yAxisID = "sales-price"
				datasets.push(o)
			})
		}
		//? Individual Floorplans scatter
		if (this.state.showIndividualFloorplans) {
			let trendStore = {}
			let floorplans = this.generateFloorplans()
			_.forEach(floorplans, (v) => {
				if (!v.sqft) return
				_.forEach(v.lot_types, (r) => {
					if (this.props.activeProperties[0] !== r.property) return
					let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
					if (!lotType) return
					if (useManual && !r.manual_base_price) return
					else if (!useManual && !r.base_price) return
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
					let path = `${lotType.name.toString()}`
					if (!_.has(trendStore, path)) {
						trendStore[path] = []
					}
					trendStore[path].push({
						x: v.sqft,
						y: useManual ? r.manual_base_price : r.base_price,
						name: v.name,
					})
				})
			})
			let count = 0
			_.forEach(trendStore, (v, k) => {
				labels.push(k)
				//let lookup = _.find(datasets, { label: k })
				//let color = lookup ? lookup.backgroundColor : colorArray[count]
				let color = colorArray[count]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: k,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(k)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				datasets.push({
					label: `FP | ${k}`,
					labelGroup: k,
					type: "scatter",
					hidden: false,
					backgroundColor: color,
					yAxisID: "sales-price",
					data: v,
				})
				count++
			})
		}
		//? Specs
		if (this.state.showSpecs) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			let specs = _.filter(this.props.payload.exec.lots, (v) => {
				if (!this.state.includePremiums && v.premium) return false
				if (v.lot_status !== "Closed" && v.start_date && v.marketing_price) {
					return v
				}
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: v.marketing_price,
					address: v.address,
				})
			})
			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				// Table Data
				lotTypeTableData.push({
					queryType: "Specs",
					type: lotType.name,
					date: v.sale_date,
					price: v.marketing_price,
					sqft: v.sqft,
				})
			})

			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.labelGroup = r.label
				o.data = r.data
				o.label = `Specs | ${r.label}`
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [2, 3]
				o.yAxisID = "sales-price"
				datasets.push(o)
			})
		}
		//? Individual Specs Scatter
		if (this.state.showIndividualSpecs) {
			let trendStore = {}
			let specs = _.filter(this.props.payload.exec.lots, (v) => {
				if (!this.state.includePremiums && v.premium) return false
				if (v.lot_status !== "Closed" && v.start_date && v.marketing_price) {
					return v
				}
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: v.marketing_price,
					address: v.address,
				})
			})
			let count = 0
			_.forEach(trendStore, (v, k) => {
				labels.push(k)
				//let lookup = _.find(datasets, { label: k })
				//let color = lookup ? lookup.backgroundColor : colorArray[count]
				let color = colorArray[count]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: k,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(k)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				datasets.push({
					label: `Spec | ${k}`,
					labelGroup: k,
					type: "scatter",
					hidden: false,
					backgroundColor: color,
					yAxisID: "sales-price",
					data: v,
				})
				count++
			})
		}
		//? Sales PPSQFT
		if (this.state.showPPSQFT) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				let ppsqft = 0
				if (!this.state.includePremiums && v.premium) {
					ppsqft = (v.price - parseFloat(v.premium)) / v.sqft
				} else {
					ppsqft = v.price / v.sqft
				}
				trendStore[path].push({
					x: v.sqft,
					y: ppsqft,
					address: v.address,
				})
			})

			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})

			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
			})
			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.label = `Sales PPSQFT | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.borderDash = [15, 5]
				o.fill = false
				o.hidden = false
				o.yAxisID = "ppsqft"
				datasets.push(o)
			})
		}
		//? Specs PPSQFT
		if (this.state.showSpecsPPSQFT) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			let specs = _.filter(this.props.payload.exec.lots, (v) => {
				if (!this.state.includePremiums && v.premium) return false
				if (v.lot_status !== "Closed" && v.start_date && v.marketing_price) {
					return v
				}
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				let ppsqft = 0
				if (!this.state.includePremiums && v.premium) {
					ppsqft = (v.marketing_price - parseFloat(v.premium)) / v.sqft
				} else {
					ppsqft = v.marketing_price / v.sqft
				}
				trendStore[path].push({
					x: v.sqft,
					y: ppsqft,
					address: v.address,
				})
			})
			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (!lotType || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${lotType.name.toString()}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				// Table Data
				lotTypeTableData.push({
					queryType: "Specs PPSQFT",
					type: lotType.name,
					date: v.sale_date,
					price: v.marketing_price,
					sqft: v.sqft,
				})
			})

			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.labelGroup = r.label
				o.data = r.data
				o.label = `Specs PPSQFT | ${r.label}`
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [2, 3]
				o.yAxisID = "ppsqft"
				datasets.push(o)
			})
		}

		labels = _.uniq(labels)
		let lotTypeDatasets = { datasets, labels }
		if (this.state.manualLotTypes) lotTypeDatasets = this.addManualLinesLotType(lotTypeDatasets)

		_.forEach(lotTypeTableData, (v) => {
			v.ppsqft = null
			if (v.sqft && v.price) {
				v.ppsqft = v.price / v.sqft
			}
		})

		const lotTypeOptions = {
			legend: {
				display: true,
				position: "bottom",
				onClick: (event, item, legend) => {
					// Go through datasets to find labelGroups and flip them
					let looper = this.state.lotTypeDatasets || lotTypeDatasets
					_.forEach(looper.datasets, (v) => {
						if (v.labelGroup == item.text || (item.labelGroup == "Manual" && v.label == item.text)) {
							v.hidden = !v.hidden
						}
					})
					this.setState({ lotTypeDatasets: looper })
				},
				labels: {
					boxWidth: 20,
					usePointStyle: true,
					generateLabels(chart) {
						const data = chart.data
						if (data.labels.length && data.datasets.length) {
							const {
								labels: { pointStyle },
							} = chart.legend.options
							return data.labels.map((label, i) => {
								// Check manuals first
								let ds = _.find(data.datasets, { labelGroup: label })
								if (!ds) {
									ds = _.find(data.datasets, { label: label })
								}
								if (!ds) {
									console.log(label)
									return ""
								}
								let lookup = _.find(data.datasets, { labelGroup: label })
								if (!lookup && ds.labelGroup !== "Manual") {
									return ""
								}
								let color = ds.backgroundColor
								let hidden = data.datasets[i].hidden
								return {
									text: label,
									fillStyle: color,
									strokeStyle: color,
									labelGroup: ds.labelGroup,
									//lineWidth: style.borderWidth,
									pointStyle: pointStyle,
									hidden,
									// Extra data used for toggling the correct item
									index: i,
								}
							})
						}
						return []
					},
				},
			},
			plugins: {
				datalabels: {
					display: this.state.showLabels,
					align: "top",
					anchor: "center",
					color: "rgba(129,129,129,.8)",
					formatter: function (value, context) {
						if (value.address) return ""
						if (context.dataIndex == 1) {
							return context.dataset.label
						} else {
							return ""
						}
					},
				},
			},
			tooltips: {
				callbacks: {
					title: function (tooltipItem, data) {
						return parseInt(tooltipItem[0].xLabel).toLocaleString()
					},
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || ""

						if (label) {
							label += ": "
						}
						//? on individual floorplan scatter, add the plan name.  Scatters we should be able to give extra details because it's showing what makes up teh trend line, not the actual math behind the createTrend.
						try {
							if (data?.datasets?.[tooltipItem.datasetIndex]?.label.includes("FP |")) {
								let planName = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].name
								label += `${planName} | `
							}
							if (data?.datasets?.[tooltipItem.datasetIndex]?.label.includes("Spec |")) {
								let address = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].address
								label += `${address} | `
							}
						} catch (e) {
							console.log(e)
						}

						label += "$" + parseInt(tooltipItem.yLabel).toLocaleString()
						return label
					},
				},
			},
			scales: {
				xAxes: [
					{
						type: "linear",
						position: "bottom",
						ticks: {
							stepSize: 100,
							beginAtZero: this.state.zeroBasedAxis,
							callback: function (value, index, values) {
								return parseInt(value).toLocaleString()
							},
						},
						scaleLabel: {
							display: true,
							labelString: "Home Square Footage",
						},
					},
				],
				yAxes: [
					{
						type: "linear",
						position: "bottom",
						id: "sales-price",
						beginAtZero: true,
						ticks: {
							stepSize: 50000,
							beginAtZero: this.state.zeroBasedAxis,
							callback: function (value, index, values) {
								return "$" + parseInt(value).toLocaleString()
							},
						},
						scaleLabel: {
							display: true,
							labelString: "Home Sales Price",
						},
					},
					{
						id: "ppsqft",
						type: "linear",
						position: "right",
						scaleLabel: {
							display: this.state.showPPSQFT ? true : false,
							labelString: "PPSQFT",
						},
					},
				],
			},
			layout: {
				padding: {
					right: 30,
					top: 30,
				},
			},
		}
		this.setState({ lotTypeDatasets, lotTypeTableData, lotTypeOptions, originalLotTypeDataSets: lotTypeDatasets })
	}

	buildBuilderData() {
		let model = _.cloneDeep(this.model)
		let labels = []
		let datasets = []
		let builderTableData = []
		let colors = {}
		let useManual = settings?.useFloorplanManualBasePricing
		//? First create an object with all the colors broken out by lot type + builder, then use it to give the colors to the below lines
		let colorKey = 0
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			//if (!this.state.includePremiums && v.premium) return
			let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!lotType || !v.sqft || !v.price || !builder) {
				return
			}
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let path = `${builder.name} ${lotType.name}`
			if (!_.has(colors, path)) {
				if (builder.color) colors[path] = builder.color
				else {
					colors[path] = colorArray[colorKey]
					colorKey++
				}
			}
		})
		// Now also go through the floorplans
		let floorplans = this.generateFloorplans()
		_.forEach(floorplans, (v) => {
			_.forEach(v.lot_types, (r) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !builder) {
					return
				}
				if (useManual && !r.manual_base_price) return
				else if (!useManual && !r.base_price) return
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(colors, path)) {
					if (builder.color) colors[path] = builder.color
					else {
						colors[path] = colorArray[colorKey]
						colorKey++
					}
				}
			})
		})
		//? Add in manual line colors
		_.forEach(this.state.manualBuilder, (v) => {
			colors[v.lot_type] = colorArray[colorKey]
			colorKey++
		})
		//? Actual Sales
		if (this.state.showSales) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					address: v.address,
				})
			})

			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})

			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let school = _.find(this.props.payload.public.isds, { id: v.isd })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
				// Table Data
				builderTableData.push({
					queryType: "Sales",
					builder: builder ? builder.name : "",
					type: lotType.name,
					date: v.sale_date,
					price: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					sqft: v.sqft,
					isd: school ? school.code : "",
				})
			})

			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})

			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colors[r.label]
				var o = _.cloneDeep(model)
				o.label = `Sales | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				datasets.push(o)
			})
		}
		//? Individual Sales scatter
		if (this.state.showIndividual) {
			let trendStore = {}
			_.forEach(this.props.payload.sales.current, (v) => {
				//if (!this.state.includePremiums && v.premium) return
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					address: v.address,
				})
			})
			let count = 0
			_.forEach(trendStore, (v, k) => {
				labels.push(k)
				let color = colors[k]
				datasets.push({
					label: `Sale | ${k}`,
					labelGroup: k,
					type: "scatter",
					hidden: false,
					backgroundColor: color,
					data: v,
				})
				count++
			})
		}
		//? Square Footage
		if (this.state.showSales && this.state.showSquareFootage) {
			let data = []
			_.forEach(this.props.payload.public.lot_types, (v) => {
				if (this.props.activeProperties[0] !== v.property) return
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.id)) return
				if (v.sqft_min && v.sqft_max) {
					data.push({
						label: v.name,
						data: [
							{ x: v.sqft_min, y: 0 },
							{ x: v.sqft_max, y: 0 },
						],
					})
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.label = `Sqft | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [5, 3]
				datasets.push(o)
			})
		}
		//? Floorplans
		if (this.state.showFloorplans) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			let floorplans = this.generateFloorplans()
			_.forEach(floorplans, (v) => {
				if (!v.sqft) return
				_.forEach(v.lot_types, (r) => {
					if (this.props.activeProperties[0] !== r.property) return
					let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
					let builder = _.find(this.props.payload.public.builders, { id: v.builder })
					if (!lotType || !builder) {
						return
					}
					if (useManual && !r.manual_base_price) return
					else if (!useManual && !r.base_price) return
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
					let path = `${builder.name} ${lotType.name}`
					if (!_.has(trendStore, path)) {
						trendStore[path] = []
					}
					trendStore[path].push({
						x: v.sqft,
						y: useManual ? r.manual_base_price : r.base_price,
						name: v.name,
					})
				})
			})
			trends = []
			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})
			lowHighs = {}
			_.forEach(floorplans, (v) => {
				if (!v.sqft) return
				_.forEach(v.lot_types, (r) => {
					if (this.props.activeProperties[0] !== r.property) return
					let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
					let builder = _.find(this.props.payload.public.builders, { id: v.builder })
					if (!lotType || !builder) {
						return
					}
					if (useManual && !r.manual_base_price) return
					else if (!useManual && !r.base_price) return
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
					let path = `${builder.name} ${lotType.name}`
					if (!_.has(lowHighs, path)) {
						lowHighs[path] = {
							low: { x: 99999, y: 0 },
							high: { x: 0, y: 0 },
						}
					}

					if (v.sqft < lowHighs[path].low.x) {
						lowHighs[path].low = {
							x: v.sqft,
							y: v.price,
						}
					}
					if (v.sqft > lowHighs[path].high.x) {
						lowHighs[path].high = {
							x: v.sqft,
							y: v.price,
						}
					}
					// Table Data
					builderTableData.push({
						queryType: "Floorplan",
						builder: builder ? builder.name : "",
						type: lotType.name,
						floorplan: v.name,
						price: useManual ? r.manual_base_price : r.base_price,
						sqft: v.sqft,
					})
				})
			})
			storage = {}
			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
					return
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colors[r.label]
				var o = _.cloneDeep(model)
				o.labelGroup = r.label
				o.data = r.data
				o.label = `Floorplan | ${r.label}`
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [15, 5]
				datasets.push(o)
			})
		}
		//? Individual Floorplans scatter
		if (this.state.showIndividualFloorplans) {
			let trendStore = {}
			let floorplans = this.generateFloorplans()
			_.forEach(floorplans, (v) => {
				if (!v.sqft) return
				_.forEach(v.lot_types, (r) => {
					if (this.props.activeProperties[0] !== r.property) return
					let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
					let builder = _.find(this.props.payload.public.builders, { id: v.builder })
					if (!lotType || !builder) {
						return
					}
					if (useManual && !r.manual_base_price) return
					else if (!useManual && !r.base_price) return
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(r.lot_type)) return
					let path = `${builder.name} ${lotType.name}`
					if (!_.has(trendStore, path)) {
						trendStore[path] = []
					}
					trendStore[path].push({
						x: v.sqft,
						y: useManual ? r.manual_base_price : r.base_price,
						name: v.name,
					})
				})
			})
			let count = 0
			_.forEach(trendStore, (v, k) => {
				labels.push(k)
				//let lookup = _.find(datasets, { label: k })
				//let color = lookup ? lookup.backgroundColor : colorArray[count]
				let color = colorArray[count]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: k,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(k)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				datasets.push({
					label: `FP | ${k}`,
					labelGroup: k,
					type: "scatter",
					hidden: false,
					backgroundColor: color,
					data: v,
				})
				count++
			})
		}
		//? Specs
		if (this.state.showSpecs) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			let specs = _.filter(this.props.payload.exec.lots, (v) => {
				if (!this.state.includePremiums && v.premium) return false
				if (v.lot_status !== "Closed" && v.start_date && v.marketing_price) {
					return v
				}
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.marketing_price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: v.marketing_price,
					address: v.address,
				})
			})
			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.marketing_price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				// Table Data
				builderTableData.push({
					queryType: "Specs",
					type: lotType.name,
					builder: builder ? builder.name : "",
					date: v.sale_date,
					sale_price: v.marketing_price,
					sqft: v.sqft,
				})
			})

			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
					return
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colors[r.label]
				var o = _.cloneDeep(model)
				o.labelGroup = r.label
				o.data = r.data
				o.label = `Specs | ${r.label}`
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [2, 3]
				datasets.push(o)
			})
		}
		//? Individual Specs Scatter
		if (this.state.showIndividualSpecs) {
			let trendStore = {}
			let specs = _.filter(this.props.payload.exec.lots, (v) => {
				if (!this.state.includePremiums && v.premium) return false
				if (v.lot_status !== "Closed" && v.start_date && v.marketing_price) {
					return v
				}
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.builder || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				trendStore[path].push({
					x: v.sqft,
					y: v.marketing_price,
					address: v.address,
				})
			})
			let count = 0
			_.forEach(trendStore, (v, k) => {
				labels.push(k)
				//let lookup = _.find(datasets, { label: k })
				//let color = lookup ? lookup.backgroundColor : colorArray[count]
				let color = colorArray[count]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: k,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(k)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				datasets.push({
					label: `Spec | ${k}`,
					labelGroup: k,
					type: "scatter",
					hidden: false,
					backgroundColor: color,
					data: v,
				})
				count++
			})
		}
		//? Sales PPSQFT
		if (this.state.showPPSQFT) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				let ppsqft = 0
				if (!this.state.includePremiums && v.premium) {
					ppsqft = (v.price - parseFloat(v.premium)) / v.sqft
				} else {
					ppsqft = v.price / v.sqft
				}
				trendStore[path].push({
					x: v.sqft,
					y: ppsqft,
					address: v.address,
				})
			})

			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})

			_.forEach(this.props.payload.sales.current, (v) => {
				if (v.bustout_date || v.transfer_date || v.cancel_date) {
					return
				}
				//if (!this.state.includePremiums && v.premium) return
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
					}
				}
			})

			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})

			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colors[r.label]
				var o = _.cloneDeep(model)
				o.label = `PPSQFT | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.borderDash = [15, 5]
				o.yAxisID = "ppsqft"
				o.fill = false
				o.hidden = false
				datasets.push(o)
			})
		}
		//? Specs PPSQFT
		if (this.state.showSpecsPPSQFT) {
			let trends = []
			let lowHighs = {}
			let storage = {}
			let data = []
			let trendStore = {}
			let specs = _.filter(this.props.payload.exec.lots, (v) => {
				if (!this.state.includePremiums && v.premium) return false
				if (v.lot_status !== "Closed" && v.start_date && v.marketing_price) {
					return v
				}
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.marketing_price || !builder) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name.toString()}`
				if (!_.has(trendStore, path)) {
					trendStore[path] = []
				}
				let ppsqft = 0
				if (!this.state.includePremiums && v.premium) {
					ppsqft = (v.marketing_price - parseFloat(v.premium)) / v.sqft
				} else {
					ppsqft = v.marketing_price / v.sqft
				}
				trendStore[path].push({
					x: v.sqft,
					y: ppsqft,
					address: v.address,
				})
			})
			_.forEach(trendStore, (v, k) => {
				let d = { type: k, trend: createTrend(v, "x", "y") }
				if (trendStore[k].length == 1) {
					d.solo = {
						x: v[0].x,
						y: v[0].y,
					}
				}
				trends.push(d)
			})
			_.forEach(specs, (v) => {
				let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!lotType || !v.sqft || !v.marketing_price) {
					return
				}
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
				let path = `${builder.name} ${lotType.name.toString()}`
				if (!_.has(lowHighs, path)) {
					lowHighs[path] = {
						low: { x: 99999, y: 0 },
						high: { x: 0, y: 0 },
					}
				}

				if (v.sqft < lowHighs[path].low.x) {
					lowHighs[path].low = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
				if (v.sqft > lowHighs[path].high.x) {
					lowHighs[path].high = {
						x: v.sqft,
						y: v.marketing_price,
					}
				}
			})

			_.forEach(trends, (v) => {
				let outers = lowHighs[v.type]
				if (!outers) {
					console.log("Cannot find outer?", v.type)
				}
				let path = `${v.type.toString()}`
				if (!_.has(storage, path)) {
					storage[path] = []
				}
				if (v.solo) {
					storage[path].push({ x: v.solo.x, y: v.solo.y })
					storage[path].push({ x: v.solo.x, y: v.solo.y })
				} else {
					let lowY = v.trend.calcY(outers.low.x)
					let highY = v.trend.calcY(outers.high.x)
					storage[path].push({ x: outers.low.x, y: lowY })
					storage[path].push({ x: outers.high.x, y: highY })
				}
			})
			storage = helpers.orderByLotTypePoints(storage)
			data = _.map(storage, (v, k) => {
				return {
					data: v.data,
					label: v.name,
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.labelGroup = r.label
				o.data = r.data
				o.label = `Specs PPSQFT | ${r.label}`
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [2, 3]
				o.yAxisID = "ppsqft"
				datasets.push(o)
			})
		}

		_.forEach(builderTableData, (v) => {
			v.ppsqft = null
			if (v.sqft && v.price) {
				v.ppsqft = v.price / v.sqft
			}
		})

		labels = _.uniq(labels)
		let builderDatasets = { datasets, labels }
		if (this.state.manualBuilder) builderDatasets = this.addManualBuilder(builderDatasets, colors)
		const builderOptions = {
			legend: {
				display: true,
				position: "bottom",
				onClick: (event, item, legend) => {
					// Go through datasets to find labelGroups and flip them
					let looper = this.state.builderDatasets || builderDatasets
					_.forEach(looper.datasets, (v) => {
						if (v.labelGroup == item.text || (item.labelGroup == "Manual" && v.label == item.text)) {
							v.hidden = !v.hidden
						}
					})
					this.setState({ builderDatasets: looper })
				},
				labels: {
					boxWidth: 20,
					usePointStyle: true,
					generateLabels(chart) {
						const data = chart.data
						if (data.labels.length && data.datasets.length) {
							const {
								labels: { pointStyle },
							} = chart.legend.options
							return data.labels.map((label, i) => {
								// Check manuals first
								let ds = _.find(data.datasets, { labelGroup: label })
								if (!ds) {
									ds = _.find(data.datasets, { label: label })
								}
								if (!ds) {
									console.log(label)
									return ""
								}
								let lookup = _.find(data.datasets, { labelGroup: label })
								if (!lookup && ds.labelGroup !== "Manual") {
									return ""
								}
								let color = ds.backgroundColor
								let hidden = data.datasets[i].hidden
								return {
									text: label,
									fillStyle: color,
									strokeStyle: color,
									labelGroup: ds.labelGroup,
									//lineWidth: style.borderWidth,
									pointStyle: pointStyle,
									hidden,
									// Extra data used for toggling the correct item
									index: i,
								}
							})
						}
						return []
					},
				},
			},
			plugins: {
				datalabels: {
					display: this.state.showLabels,
					align: "top",
					anchor: "end",
					color: "rgba(129,129,129,.8)",
					formatter: function (value, context) {
						if (value.address) return ""
						if (context.dataIndex == 1) {
							return context.dataset.label
						} else {
							return ""
						}
					},
				},
			},
			tooltips: {
				callbacks: {
					title: function (tooltipItem, data) {
						return parseInt(tooltipItem[0].xLabel).toLocaleString()
					},
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || ""

						if (label) {
							label += ": "
						}
						//? on individual floorplan scatter, add the plan name.  Scatters we should be able to give extra details because it's showing what makes up teh trend line, not the actual math behind the createTrend.
						try {
							if (data?.datasets?.[tooltipItem.datasetIndex]?.label.includes("FP |")) {
								let planName = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].name
								label += `${planName} | `
							}
							if (data?.datasets?.[tooltipItem.datasetIndex]?.label.includes("Spec |")) {
								let address = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].address
								label += `${address} | `
							}
						} catch (e) {
							console.log(e)
						}
						label += "$" + parseInt(tooltipItem.yLabel).toLocaleString()
						return label
					},
				},
			},
			scales: {
				xAxes: [
					{
						type: "linear",
						position: "bottom",
						ticks: {
							stepSize: 100,
							beginAtZero: this.state.zeroBasedAxis,
							callback: function (value, index, values) {
								return parseInt(value).toLocaleString()
							},
						},
						scaleLabel: {
							display: true,
							labelString: "Home Square Footage",
						},
					},
				],
				yAxes: [
					{
						type: "linear",
						position: "bottom",
						ticks: {
							stepSize: 50000,
							beginAtZero: this.state.zeroBasedAxis,
							callback: function (value, index, values) {
								return "$" + parseInt(value).toLocaleString()
							},
						},
						scaleLabel: {
							display: true,
							labelString: "Home Sales Price",
						},
					},
					{
						id: "ppsqft",
						type: "linear",
						position: "right",
						scaleLabel: {
							display: this.state.showPPSQFT ? true : false,
							labelString: "PPSQFT",
						},
					},
				],
			},
			layout: {
				padding: {
					right: 100,
					top: 30,
				},
			},
		}
		this.setState({
			builderDatasets,
			builderTableData,
			builderOptions,
			originalBuilderDataSets: builderDatasets,
			builderColors: colors,
		})
	}

	buildSchoolData() {
		let model = _.cloneDeep(this.model)
		let trendStore = {}
		let labels = []
		_.forEach(this.props.payload.sales.current, (v) => {
			//if (!this.state.includePremiums && v.premium) return
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let school = _.find(this.props.payload.public.isds, { id: v.isd })
			if (!lotType || !v.sqft || !v.price || !school) {
				return
			}
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let path = `${school.code} ${lotType.name}`
			if (!_.has(trendStore, path)) {
				trendStore[path] = []
			}
			trendStore[path].push({
				x: v.sqft,
				y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
				school: school.code,
				lot_type: lotType.name,
			})
		})
		let trends = []
		_.forEach(trendStore, (v, k) => {
			let d = { type: k, trend: createTrend(v, "x", "y"), lot_type: v[0].lot_type }
			if (trendStore[k].length == 1) {
				d.solo = {
					x: v[0].x,
					y: v[0].y,
				}
			}
			trends.push(d)
		})
		let lowHighs = {}
		let schoolTableData = []
		_.forEach(this.props.payload.sales.current, (v) => {
			//if (!this.state.includePremiums && v.premium) return
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let lotType = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let school = _.find(this.props.payload.public.isds, { id: v.isd })
			if (!lotType || !v.sqft || !v.price || !school) {
				return
			}
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let path = `${school.code} ${lotType.name}`
			if (!_.has(lowHighs, path)) {
				lowHighs[path] = {
					low: { x: 99999, y: 0 },
					high: { x: 0, y: 0 },
				}
			}

			if (v.sqft < lowHighs[path].low.x) {
				lowHighs[path].low = {
					x: v.sqft,
					y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
				}
			}
			if (v.sqft > lowHighs[path].high.x) {
				lowHighs[path].high = {
					x: v.sqft,
					y: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
				}
			}

			// Table Data
			schoolTableData.push({
				type: lotType.name,
				date: v.sale_date,
				price: !this.state.includePremiums && v.premium ? v.price - parseFloat(v.premium) : v.price,
				sqft: v.sqft,
				school: school.code || "",
			})
		})
		let storage = {}
		_.forEach(trends, (v) => {
			let outers = lowHighs[v.type]
			if (!outers) {
				console.log("Cannot find outer?", v.type)
			}
			let path = `${v.type}`
			if (!_.has(storage, path)) {
				storage[path] = []
			}
			if (v.solo) {
				storage[path].push({ x: v.solo.x, y: v.solo.y, lot_type: v.lot_type })
				storage[path].push({ x: v.solo.x, y: v.solo.y, lot_type: v.lot_type })
			} else {
				let lowY = v.trend.calcY(outers.low.x)
				let highY = v.trend.calcY(outers.high.x)
				storage[path].push({ x: outers.low.x, y: lowY, lot_type: v.lot_type })
				storage[path].push({ x: outers.high.x, y: highY, lot_type: v.lot_type })
			}
		})
		storage = helpers.orderByLotTypePoints(storage)
		let data = _.map(storage, (v, k) => {
			return {
				data: v.data,
				label: v.name,
			}
		})

		var datasets = []
		_.forEach(data, (r, k) => {
			labels.push(r.label)
			let color = colorArray[k]
			let lt = _.get(r, `data[0].lot_type`)
			let typeColorLookup = _.find(this.props.payload.public.lot_types, {
				name: lt,
				property: this.props.activeProperties[0],
			})
			let lookup = _.find(datasets, (v) => {
				if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
			})
			if (typeColorLookup && typeColorLookup.color) {
				color = typeColorLookup.color
			} else if (lookup && lookup.backgroundColor) {
				color = lookup.backgroundColor
			}
			var o = _.cloneDeep(model)
			o.data = r.data
			o.label = r.label
			o.labelGroup = r.label
			o.borderColor = color
			o.pointHoverBackgroundColor = color
			o.pointBackgroundColor = color
			o.backgroundColor = color
			o.fill = false
			if (r.projection) {
				o.borderDash = [5, 4]
			}
			datasets.push(o)
		})
		//? Now put individual sales in the datasets
		if (this.state.showIndividual) {
			_.forEach(trendStore, (v, k) => {
				let lookup = _.find(datasets, { label: k })
				if (!lookup) return
				let color = lookup.backgroundColor
				datasets.push({
					label: `Sale | ${k}`,
					type: "scatter",
					labelGroup: k,
					hidden: false,
					backgroundColor: color,
					data: v,
				})
			})
		}
		//? Square Footage
		if (this.state.showSales && this.state.showSquareFootage) {
			let data = []
			_.forEach(this.props.payload.public.lot_types, (v) => {
				if (this.props.activeProperties[0] !== v.property) return
				if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.id)) return
				if (v.sqft_min && v.sqft_max) {
					data.push({
						label: v.name,
						data: [
							{ x: v.sqft_min, y: 0 },
							{ x: v.sqft_max, y: 0 },
						],
					})
				}
			})
			_.forEach(data, (r, k) => {
				labels.push(r.label)
				let color = colorArray[k]
				let typeColorLookup = _.find(this.props.payload.public.lot_types, {
					name: r.label,
					property: this.props.activeProperties[0],
				})
				let lookup = _.find(datasets, (v) => {
					if (v.label && typeof v.label == "string" && v.label.includes(r.label)) return true
				})
				if (typeColorLookup && typeColorLookup.color) {
					color = typeColorLookup.color
				} else if (lookup && lookup.backgroundColor) {
					color = lookup.backgroundColor
				}
				var o = _.cloneDeep(model)
				o.label = `Sqft | ${r.label}`
				o.data = r.data
				o.labelGroup = r.label
				o.borderColor = color
				o.pointHoverBackgroundColor = color
				o.pointBackgroundColor = color
				o.backgroundColor = color
				o.fill = false
				o.hidden = false
				o.borderDash = [5, 3]
				datasets.push(o)
			})
		}
		labels = _.uniq(labels)
		let schoolDatasets = { datasets, labels }
		if (this.state.manualSchools) schoolDatasets = this.addManualSchools(schoolDatasets)
		const schoolOptions = {
			legend: {
				display: true,
				position: "bottom",
				onClick: (event, item, legend) => {
					// Go through datasets to find labelGroups and flip them
					let looper = this.state.schoolDatasets || schoolDatasets
					_.forEach(looper.datasets, (v) => {
						if (v.labelGroup == item.text || (item.labelGroup == "Manual" && v.label == item.text)) {
							v.hidden = !v.hidden
						}
					})
					this.setState({ schoolDatasets: looper })
				},
				labels: {
					boxWidth: 20,
					usePointStyle: true,
					generateLabels(chart) {
						const data = chart.data
						if (data.labels.length && data.datasets.length) {
							const {
								labels: { pointStyle },
							} = chart.legend.options
							return data.labels.map((label, i) => {
								// Check manuals first
								let ds = _.find(data.datasets, { labelGroup: label })
								if (!ds) {
									ds = _.find(data.datasets, { label: label })
								}
								if (!ds) {
									console.log(label)
									return ""
								}
								let lookup = _.find(data.datasets, { labelGroup: label })
								if (!lookup && ds.labelGroup !== "Manual") {
									console.log(label)
									return ""
								}
								let color = ds.backgroundColor
								let hidden = data.datasets[i].hidden

								return {
									text: label,
									fillStyle: color,
									strokeStyle: color,
									labelGroup: ds.labelGroup,
									//lineWidth: style.borderWidth,
									pointStyle: pointStyle,
									hidden,
									// Extra data used for toggling the correct item
									index: i,
								}
							})
						}
						return []
					},
				},
			},
			plugins: {
				datalabels: {
					display: this.state.showLabels,
					align: "top",
					anchor: "end",
					color: "rgba(129,129,129,.8)",
					formatter: function (value, context) {
						if (value.address) return ""
						if (context.dataIndex == 1) {
							return context.dataset.label
						} else {
							return ""
						}
					},
				},
			},
			tooltips: {
				callbacks: {
					title: function (tooltipItem, data) {
						return parseInt(tooltipItem[0].xLabel).toLocaleString()
					},
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || ""

						if (label) {
							label += ": "
						}
						label += "$" + parseInt(tooltipItem.yLabel).toLocaleString()
						return label
					},
				},
			},
			scales: {
				xAxes: [
					{
						type: "linear",
						position: "bottom",
						ticks: {
							stepSize: 100,
							beginAtZero: this.state.zeroBasedAxis,
							callback: function (value, index, values) {
								return parseInt(value).toLocaleString()
							},
						},
						scaleLabel: {
							display: true,
							labelString: "Home Square Footage",
						},
					},
				],
				yAxes: [
					{
						type: "linear",
						position: "bottom",
						ticks: {
							stepSize: 50000,
							beginAtZero: this.state.zeroBasedAxis,
							callback: function (value, index, values) {
								return "$" + parseInt(value).toLocaleString()
							},
						},
						scaleLabel: {
							display: true,
							labelString: "Home Sales Price",
						},
					},
				],
			},
			layout: {
				padding: {
					right: 30,
					top: 30,
				},
			},
		}
		this.setState({ schoolDatasets, schoolTableData, schoolOptions, originalSchoolDataSets: schoolDatasets })
	}

	lotTypes = () => {
		let ret = []
		_.forEach(this.props.payload.public.lot_types, (v) => {
			if (this.props.activeProperties.includes(v.property)) {
				let property = _.find(this.props.payload.public.properties, { id: v.property })
				let name = property.name || ""
				ret.push({
					label: this.props.activeProperties.length > 1 ? `${name} | ${v.name}` : `${v.name}`,
					value: v.id,
				})
			}
		})
		return ret
	}

	lotTypeClick = (i) => {
		if (!i) return
		// for editing lot type manuals
		let set = this.state?.lotTypeDatasets?.datasets[i]
		if (set.labelGroup !== "Manual") return
		this.setState({
			manualLotTypeFields: {
				lot_type: set?.label,
				sqft_low: set?.data[0]?.x,
				sqft_high: set?.data[1]?.x,
				price_low: set?.data[0]?.y,
				price_high: set?.data[1]?.y,
			},
			manualLotTypeModal: true,
		})
	}

	builderClick = (i) => {
		if (!i) return
		// for editing lot type manuals
		let set = this.state?.builderDatasets?.datasets[i]
		if (set.labelGroup !== "Manual") return
		this.setState({
			manualBuilderFields: {
				lot_type: set?.label,
				sqft_low: set?.data[0]?.x,
				sqft_high: set?.data[1]?.x,
				price_low: set?.data[0]?.y,
				price_high: set?.data[1]?.y,
			},
			manualBuilderModal: true,
		})
	}

	schoolClick = (i) => {
		if (!i) return
		// for editing lot type manuals
		let set = this.state?.schoolDatasets?.datasets[i]
		if (set.labelGroup !== "Manual") return
		this.setState({
			manualSchoolFields: {
				lot_type: set?.label,
				sqft_low: set?.data[0]?.x,
				sqft_high: set?.data[1]?.x,
				price_low: set?.data[0]?.y,
				price_high: set?.data[1]?.y,
			},
			manualSchoolsModal: true,
		})
	}

	controls = () => {
		return (
			<div className="" style={{ marginBottom: 25 }}>
				<div className="">
					<div style={{ minWidth: 300 }}>
						<h4 className="blue text-sm font-bold">Active Lot Types:</h4>
						<ReactSelect
							name={`activeLotType`}
							options={this.lotTypes()}
							value={this.state.activeLotTypes}
							onBlur={() => {}}
							onChange={(k, v) => {
								if (!v) v = []
								this.setState({ activeLotTypes: v }, () => {
									this.buildAll()
								})
							}}
							isMulti
						/>
					</div>
					<div className="flex justify-end">
						{this.state.showSales || this.state.showIndividual ? (
							<div
								className="switch"
								style={{ marginTop: 40, marginLeft: 5 }}
								onClick={(e) => e.stopPropagation()}>
								<Switch
									height={20}
									width={40}
									onChange={() =>
										this.setState({ includePremiums: !this.state.includePremiums }, () => {
											this.buildAll()
										})
									}
									checked={this.state.includePremiums}
									checkedIcon={false}
									uncheckedIcon={false}
									key={"switch"}
									id={"switch"}
								/>
								<p className="!text-xs !ml-2">Include Premiums</p>
							</div>
						) : null}
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showLabels: !this.state.showLabels }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showLabels}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-xs !ml-2">Show Labels</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ zeroBasedAxis: !this.state.zeroBasedAxis }, () => {
										this.buildAll()
									})
								}
								checked={this.state.zeroBasedAxis}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-xs !ml-2">Zero Based Axis</p>
						</div>
					</div>
					<div className="flex">
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showSales: !this.state.showSales }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showSales}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Sales</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showIndividual: !this.state.showIndividual }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showIndividual}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Individual Sales</p>
						</div>
						{/* I dont know what this did? */}
						{/* {this.state.showSales ? (
							<div
								className="switch"
								style={{ marginTop: 40, marginLeft: 5 }}
								onClick={(e) => e.stopPropagation()}>
								<Switch
									onChange={() =>
										this.setState({ showSquareFootage: !this.state.showSquareFootage }, () => {
											this.buildAll()
										})
									}
									checked={this.state.showSquareFootage}
									checkedIcon={false}
									uncheckedIcon={false}
									key={"switch"}
									id={"switch"}
									height={20}
									width={40}
								/>
								<p className="!text-sm !ml-2">SQFT Min/Max</p>
							</div>
						) : null} */}
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showFloorplans: !this.state.showFloorplans }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showFloorplans}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Floorplans</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState(
										{ showIndividualFloorplans: !this.state.showIndividualFloorplans },
										() => {
											this.buildAll()
										}
									)
								}
								checked={this.state.showIndividualFloorplans}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Indiv Floorplans</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showSpecs: !this.state.showSpecs }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showSpecs}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Current Specs</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showIndividualSpecs: !this.state.showIndividualSpecs }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showIndividualSpecs}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Individual Specs</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showPPSQFT: !this.state.showPPSQFT }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showPPSQFT}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Sales PPSQFT</p>
						</div>
						<div
							className="switch"
							style={{ marginTop: 40, marginLeft: 5 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() =>
									this.setState({ showSpecsPPSQFT: !this.state.showSpecsPPSQFT }, () => {
										this.buildAll()
									})
								}
								checked={this.state.showSpecsPPSQFT}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={20}
								width={40}
							/>
							<p className="!text-sm !ml-2">Specs PPSQFT</p>
						</div>
					</div>
				</div>
			</div>
		)
	}

	firstGraph = () => {
		// This is broken out for the widget
		return (
			<>
				{this.props.widget ? <h2 className="mb-4">Segmentation</h2> : null}
				{this.controls()}
				<div className="reportGroup">
					{/* <div
									className="bg-red-500 px-4 py-4"
									onClick={() => {
										this.setState({
											manualLotTypes: [
												{
													lot_type: "Tester",
													sqft_low: 3500,
													sqft_high: 4500,
													price_low: 500000,
													price_high: 750000,
												},
											],
											manualLotTypeModal: false,
										})
									}}></div> */}
					<div className="flex justify-between items-center pt-6">
						<h2 className="pt-0">Segmentation By Lot Type</h2>
						<div className="flex">
							<i
								className="fa-light fa-rectangle-xmark text-blue text-2xl mr-3 cursor-pointer"
								title="Clear Manual Lines"
								onClick={() => {
									this.setState(
										{
											manualLotTypes: false,
											manualLotTypeModal: false,
										},
										() => {
											this.buildAll()
										}
									)
									localStorage.removeItem("segmentation__manualLotTypes")
								}}></i>
							<i
								className="fa-solid fa-square-plus text-blue text-2xl cursor-pointer"
								onClick={() => {
									let resetFields = _.clone(this.state.manualLotTypeFields)
									_.forEach(resetFields, (v, k) => {
										resetFields[k] = 0
										if (k === "lot_type") resetFields[k] = ""
									})
									this.setState({
										manualLotTypeModal: true,
										manualLotTypeFields: resetFields,
									})
								}}></i>
						</div>
					</div>
					<ImageExport name="Segmentation" block={true} />
					<Line
						data={this.state.lotTypeDatasets}
						options={this.state.lotTypeOptions}
						getElementAtEvent={(e) => this.lotTypeClick(e?.[0]?._datasetIndex)}
					/>
				</div>
			</>
		)
	}

	render() {
		if (this.props.widget) {
			// only return first graph
			return this.firstGraph()
		}
		if (this.props.payloadStatus) {
			return (
				<div>
					<div className="imageGroup">
						<Title title="Segmentation" />
						<div className="content">
							{this.firstGraph()}
							<h2>Table Breakout</h2>
							<FullTable
								data={this.state.lotTypeTableData}
								columns={this.state.columns}
								name="segmentation__lotType"
								title="Segmentation By Lot Type"
								defaultSorted={[
									{
										id: "type",
										desc: false,
									},
									{
										id: "sqft",
										desc: false,
									},
								]}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							{this.controls()}
							<div className="reportGroup">
								<div className="flex justify-between items-center">
									<h2>Segmentation By Builder + Lot Type</h2>
									<div>
										<i
											className="fa-light fa-rectangle-xmark text-blue text-2xl mr-3 cursor-pointer"
											title="Clear Manual Lines"
											onClick={() => {
												this.setState(
													{
														manualBuilder: false,
														manualBuilderModal: false,
													},
													() => {
														this.buildAll()
													}
												)
												localStorage.removeItem("segmentation__manualBuilder")
											}}></i>
										<i
											className="fa-solid fa-square-plus text-blue text-2xl cursor-pointer"
											onClick={() => {
												let resetFields = _.clone(this.state.manualBuilderFields)
												_.forEach(resetFields, (v, k) => {
													resetFields[k] = 0
													if (k === "lot_type") resetFields[k] = ""
												})
												this.setState({
													manualBuilderModal: true,
													manualBuilderFields: resetFields,
												})
											}}></i>
									</div>
								</div>
								<ImageExport name="SegmentationBuilderLotType" block={true} />
								<Line
									data={this.state.builderDatasets}
									options={this.state.builderOptions}
									getElementAtEvent={(e) => this.builderClick(e?.[0]?._datasetIndex)}
								/>
							</div>
							<h2>Table Breakout</h2>
							<FullTable
								data={this.state.builderTableData}
								columns={this.state.builderColumns}
								name="segmentation__builder"
								title="Segmentation By Builder + Lot Type"
								defaultSorted={[
									{
										id: "type",
										desc: false,
									},
									{
										id: "sqft",
										desc: false,
									},
								]}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							{this.controls()}
							<div className="reportGroup">
								<div className="flex justify-between items-center">
									<h2>Segmentation By Lot Type + School</h2>
									<div>
										<i
											className="fa-light fa-rectangle-xmark text-blue text-2xl mr-3 cursor-pointer"
											title="Clear Manual Lines"
											onClick={() => {
												this.setState(
													{
														manualSchools: false,
														manualSchoolsModal: false,
													},
													() => {
														this.buildAll()
													}
												)
												localStorage.removeItem("segmentation__manualSchools")
											}}></i>
										<i
											className="fa-solid fa-square-plus text-blue text-2xl cursor-pointer"
											onClick={() => {
												let resetFields = _.clone(this.state.manualSchoolFields)
												_.forEach(resetFields, (v, k) => {
													resetFields[k] = 0
													if (k === "lot_type") resetFields[k] = ""
												})
												this.setState({
													manualSchoolsModal: true,
													manualSchoolFields: resetFields,
												})
											}}></i>
									</div>
								</div>
								<p className="text-xs mt-3">Please note this chart only looks at sales.</p>
								<ImageExport name="SegmentationSchoolLotType" block={true} />
								<Line
									data={this.state.schoolDatasets}
									options={this.state.schoolOptions}
									getElementAtEvent={(e) => this.schoolClick(e?.[0]?._datasetIndex)}
								/>
							</div>
							<h2>Table Breakout</h2>
							<FullTable
								data={this.state.schoolTableData}
								columns={this.state.schoolColumns}
								name="segmentation__school"
								title="Segmentation By School + Lot Type"
								defaultSorted={[
									{
										id: "type",
										desc: false,
									},
									{
										id: "sqft",
										desc: false,
									},
								]}
							/>
						</div>
					</div>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.manualLotTypeModal}
						onClose={() => this.setState({ manualLotTypeModal: false })}
						center>
						<h3>Add Manual Line</h3>
						<Formik
							initialValues={this.state.manualLotTypeFields}
							enableReinitialize
							validationSchema={Yup.object().shape({
								lot_type: Yup.string().required("Required"),
								sqft_low: Yup.number().min(1, "Required").required("Required"),
								sqft_high: Yup.number().min(1, "Required").required("Required"),
								price_low: Yup.number().min(1, "Required").required("Required"),
								price_high: Yup.number().min(1, "Required").required("Required"),
							})}
							//validateOnMount={true}
							onSubmit={(values) => {
								if (!this.state.manualLotTypes) {
									this.setState(
										{
											manualLotTypes: [
												{
													...values,
												},
											],
											manualLotTypeModal: false,
										},
										() => {
											localStorage.setItem(
												"segmentation__manualLotTypes",
												JSON.stringify(this.state.manualLotTypes)
											)
										}
									)
								} else {
									let prev = _.cloneDeep(this.state.manualLotTypes)
									// figure out if this is an edit or new
									let index = _.findIndex(prev, (v) => v.lot_type === values.lot_type)
									if (index > -1) prev[index] = { ...values }
									else prev.push({ ...values })
									this.setState(
										{
											manualLotTypes: prev,
											manualLotTypeModal: false,
										},
										() => {
											localStorage.setItem(
												"segmentation__manualLotTypes",
												JSON.stringify(this.state.manualLotTypes)
											)
										}
									)
								}
							}}>
							{(f) => (
								<div>
									{/* console.log(f) */}
									<Form>
										<ul className="modalForm__list">
											<li className={fieldStatus("lot_type", f)}>
												<label htmlFor="lot_type">
													Lot Type<sup>*</sup>
												</label>
												{f.errors.lot_type && f.touched.lot_type && (
													<div className="form__message">{f.errors.lot_type}</div>
												)}
												<Field name="lot_type" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("sqft_low", f)}>
												<label htmlFor="sqft_low">
													Square Feet Low<sup>*</sup>
												</label>
												{f.errors.sqft_low && f.touched.sqft_low && (
													<div className="form__message">{f.errors.sqft_low}</div>
												)}
												<NumberField
													numeric={true}
													name="sqft_low"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_low}
													error={f.errors.sqft_low}
													value={f.values.sqft_low}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("sqft_high", f)}>
												<label htmlFor="sqft_high">
													Square Feet High<sup>*</sup>
												</label>
												{f.errors.sqft_high && f.touched.sqft_high && (
													<div className="form__message">{f.errors.sqft_high}</div>
												)}
												<NumberField
													numeric={true}
													name="sqft_high"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_high}
													error={f.errors.sqft_high}
													value={f.values.sqft_high}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("price_low", f)}>
												<label htmlFor="price_low">
													Price Low<sup>*</sup>
												</label>
												{f.errors.price_low && f.touched.price_low && (
													<div className="form__message">{f.errors.price_low}</div>
												)}
												<NumberField
													numeric={true}
													name="price_low"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price_low}
													error={f.errors.price_low}
													value={f.values.price_low}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("price_high", f)}>
												<label htmlFor="price_high">
													Price High<sup>*</sup>
												</label>
												{f.errors.price_high && f.touched.price_high && (
													<div className="form__message">{f.errors.price_high}</div>
												)}
												<NumberField
													numeric={true}
													name="price_high"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price_high}
													error={f.errors.price_high}
													value={f.values.price_high}
													thousandSeparator={true}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.manualBuilderModal}
						onClose={() => this.setState({ manualBuilderModal: false })}
						center>
						<h3>Add Manual Line</h3>
						<Formik
							initialValues={this.state.manualBuilderFields}
							enableReinitialize
							validationSchema={Yup.object().shape({
								lot_type: Yup.string().required("Required"),
								sqft_low: Yup.number().min(1, "Required").required("Required"),
								sqft_high: Yup.number().min(1, "Required").required("Required"),
								price_low: Yup.number().min(1, "Required").required("Required"),
								price_high: Yup.number().min(1, "Required").required("Required"),
							})}
							//validateOnMount={true}
							onSubmit={(values) => {
								if (!this.state.manualBuilder) {
									this.setState(
										{
											manualBuilder: [
												{
													...values,
												},
											],
											manualBuilderModal: false,
										},
										() => {
											localStorage.setItem(
												"segmentation__manualBuilder",
												JSON.stringify(this.state.manualBuilder)
											)
										}
									)
								} else {
									let prev = _.cloneDeep(this.state.manualBuilder)
									//console.log(prev, values)
									// figure out if this is an edit or new
									let index = _.findIndex(prev, (v) => v.lot_type === values.lot_type)
									if (index > -1) {
										prev[index] = { ...values }
									} else prev.push({ ...values })
									this.setState(
										{
											manualBuilder: prev,
											manualBuilderModal: false,
										},
										() => {
											localStorage.setItem(
												"segmentation__manualBuilder",
												JSON.stringify(this.state.manualBuilder)
											)
										}
									)
								}
							}}>
							{(f) => (
								<div>
									{/* console.log(f) */}
									<Form>
										<ul className="modalForm__list">
											<li className={fieldStatus("lot_type", f)}>
												<label htmlFor="lot_type">
													Lot Type<sup>*</sup>
												</label>
												{f.errors.lot_type && f.touched.lot_type && (
													<div className="form__message">{f.errors.lot_type}</div>
												)}
												<Field name="lot_type" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("sqft_low", f)}>
												<label htmlFor="sqft_low">
													Square Feet Low<sup>*</sup>
												</label>
												{f.errors.sqft_low && f.touched.sqft_low && (
													<div className="form__message">{f.errors.sqft_low}</div>
												)}
												<NumberField
													numeric={true}
													name="sqft_low"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_low}
													error={f.errors.sqft_low}
													value={f.values.sqft_low}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("sqft_high", f)}>
												<label htmlFor="sqft_high">
													Square Feet High<sup>*</sup>
												</label>
												{f.errors.sqft_high && f.touched.sqft_high && (
													<div className="form__message">{f.errors.sqft_high}</div>
												)}
												<NumberField
													numeric={true}
													name="sqft_high"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_high}
													error={f.errors.sqft_high}
													value={f.values.sqft_high}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("price_low", f)}>
												<label htmlFor="price_low">
													Price Low<sup>*</sup>
												</label>
												{f.errors.price_low && f.touched.price_low && (
													<div className="form__message">{f.errors.price_low}</div>
												)}
												<NumberField
													numeric={true}
													name="price_low"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price_low}
													error={f.errors.price_low}
													value={f.values.price_low}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("price_high", f)}>
												<label htmlFor="price_high">
													Price High<sup>*</sup>
												</label>
												{f.errors.price_high && f.touched.price_high && (
													<div className="form__message">{f.errors.price_high}</div>
												)}
												<NumberField
													numeric={true}
													name="price_high"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price_high}
													error={f.errors.price_high}
													value={f.values.price_high}
													thousandSeparator={true}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.manualSchoolsModal}
						onClose={() => this.setState({ manualSchoolsModal: false })}
						center>
						<h3>Add Manual Line</h3>
						<Formik
							initialValues={this.state.manualSchoolFields}
							enableReinitialize
							validationSchema={Yup.object().shape({
								lot_type: Yup.string().required("Required"),
								sqft_low: Yup.number().min(1, "Required").required("Required"),
								sqft_high: Yup.number().min(1, "Required").required("Required"),
								price_low: Yup.number().min(1, "Required").required("Required"),
								price_high: Yup.number().min(1, "Required").required("Required"),
							})}
							//validateOnMount={true}
							onSubmit={(values) => {
								if (!this.state.manualSchools) {
									this.setState(
										{
											manualSchools: [
												{
													...values,
												},
											],
											manualSchoolsModal: false,
										},
										() => {
											localStorage.setItem(
												"segmentation__manualSchools",
												JSON.stringify(this.state.manualSchools)
											)
										}
									)
								} else {
									let prev = _.cloneDeep(this.state.manualSchools)
									//console.log(prev, values)
									// figure out if this is an edit or new
									let index = _.findIndex(prev, (v) => v.lot_type === values.lot_type)
									if (index > -1) {
										prev[index] = { ...values }
									} else prev.push({ ...values })
									this.setState(
										{
											manualSchools: prev,
											manualSchoolsModal: false,
										},
										() => {
											localStorage.setItem(
												"segmentation__manualSchools",
												JSON.stringify(this.state.manualSchools)
											)
										}
									)
								}
							}}>
							{(f) => (
								<div>
									{/* console.log(f) */}
									<Form>
										<ul className="modalForm__list">
											<li className={fieldStatus("lot_type", f)}>
												<label htmlFor="lot_type">
													Name<sup>*</sup>
												</label>
												{f.errors.lot_type && f.touched.lot_type && (
													<div className="form__message">{f.errors.lot_type}</div>
												)}
												<Field name="lot_type" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("sqft_low", f)}>
												<label htmlFor="sqft_low">
													Square Feet Low<sup>*</sup>
												</label>
												{f.errors.sqft_low && f.touched.sqft_low && (
													<div className="form__message">{f.errors.sqft_low}</div>
												)}
												<NumberField
													numeric={true}
													name="sqft_low"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_low}
													error={f.errors.sqft_low}
													value={f.values.sqft_low}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("sqft_high", f)}>
												<label htmlFor="sqft_high">
													Square Feet High<sup>*</sup>
												</label>
												{f.errors.sqft_high && f.touched.sqft_high && (
													<div className="form__message">{f.errors.sqft_high}</div>
												)}
												<NumberField
													numeric={true}
													name="sqft_high"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_high}
													error={f.errors.sqft_high}
													value={f.values.sqft_high}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("price_low", f)}>
												<label htmlFor="price_low">
													Price Low<sup>*</sup>
												</label>
												{f.errors.price_low && f.touched.price_low && (
													<div className="form__message">{f.errors.price_low}</div>
												)}
												<NumberField
													numeric={true}
													name="price_low"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price_low}
													error={f.errors.price_low}
													value={f.values.price_low}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("price_high", f)}>
												<label htmlFor="price_high">
													Price High<sup>*</sup>
												</label>
												{f.errors.price_high && f.touched.price_high && (
													<div className="form__message">{f.errors.price_high}</div>
												)}
												<NumberField
													numeric={true}
													name="price_high"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price_high}
													error={f.errors.price_high}
													value={f.values.price_high}
													thousandSeparator={true}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Segmentation)
